import { Button, Stack, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { api } from "../../../../../utils";
import { IError } from "../../../../../models/ReportPageModels";

interface RecoverPasswordRequestModel {
    username: string;
    password: string;
}

interface RecoverPasswordResponseModel {
    data: RecoverPasswordData;
    error: IError;
}
interface RecoverPasswordData {
    status: string;
}

function RecoverAdminPassword() {
    const { enqueueSnackbar } = useSnackbar();

    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");

    const SavePassword = async () => {
        const request: RecoverPasswordRequestModel = {
            username: username,
            password: password
        };

        try {
            const response: RecoverPasswordResponseModel = await api.post("api/Admin/RecoverPassword", {
                json: request,
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error == null) {
                enqueueSnackbar("Password saved!", { variant: "success" });
                setUsername("");
                setPassword("");
            }
            else {
                enqueueSnackbar(response.error.description, { variant: "error" });
            }
        }
        catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    };

    return (
        <Stack>
            {/* Username */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '110px' }}>Username: </p>
                <TextField
                    value={username}
                    onChange={(newValue: any) => { setUsername(newValue.target.value) }}
                    sx={{ minWidth: 245 }}
                    size="small" />
            </Stack>

            {/* Password */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '110px' }}>Password: </p>
                <TextField
                    value={password}
                    onChange={(newValue: any) => { setPassword(newValue.target.value) }}
                    sx={{ minWidth: 245 }}
                    size="small" />
            </Stack>

            <Button
                variant="outlined"
                onClick={SavePassword}
                sx={{ width: '82px' }}>
                Save
            </Button>
        </Stack>
    );
};

export default RecoverAdminPassword;